import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Text,
    useMultiStyleConfig,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
} from '@chakra-ui/react'
import {ChevronDown, ChevronUp} from '../icons'
import ProductDetailBanner from '.'

const ProductDetailBannerBlock = ({productBannerInfo, onFocusLinkClick}) => {
    const style = useMultiStyleConfig('ProductDetailBanner')

    return (
        productBannerInfo &&
        productBannerInfo.length > 0 && (
            <>
                {/* --- MOBILE BANNER BLOCK --- */}
                <Box {...style.mobileBannerBlock}>
                    {productBannerInfo.length === 2 ? (
                        <Box {...style.accordionBox}>
                            <Accordion allowToggle {...style.accordion}>
                                <AccordionItem {...style.accordionItem}>
                                    {({isExpanded}) => (
                                        <>
                                            <AccordionButton {...style.accordionButton}>
                                                <Text {...style.accordionButtonText}>
                                                    <FormattedMessage
                                                        id="pdp_banner_dropdown.title"
                                                        defaultMessage="Explore the promotions for this product"
                                                    />
                                                </Text>
                                                {isExpanded ? <ChevronUp /> : <ChevronDown />}
                                            </AccordionButton>
                                            <AccordionPanel {...style.accordionPanel}>
                                                {productBannerInfo.map((bannerData, index) => (
                                                    <ProductDetailBanner
                                                        key={index}
                                                        {...bannerData}
                                                        onFocusLinkClick={onFocusLinkClick}
                                                    />
                                                ))}
                                            </AccordionPanel>
                                        </>
                                    )}
                                </AccordionItem>
                            </Accordion>
                        </Box>
                    ) : (
                        productBannerInfo.map((bannerData, index) => (
                            <ProductDetailBanner
                                key={index}
                                {...bannerData}
                                onFocusLinkClick={onFocusLinkClick}
                            />
                        ))
                    )}
                </Box>

                {/* --- DESKTOP BANNER BLOCK --- */}
                <Box {...style.desktopBannerBlock}>
                    {productBannerInfo.map((bannerData, index) => (
                        <ProductDetailBanner
                            key={index}
                            {...bannerData}
                            onFocusLinkClick={onFocusLinkClick}
                        />
                    ))}
                </Box>
            </>
        )
    )
}
ProductDetailBannerBlock.propTypes = {
    productBannerInfo: PropTypes.object,
    onFocusLinkClick: PropTypes.func,
}

export default ProductDetailBannerBlock
